import { PageHeader } from '../components/ui';
import { Chip } from '../components/ui';

/** Screens from later build phases. They keep the nav complete without pretending to work. */
export function Placeholder({ title, phase, blurb }: { title: string; phase: string; blurb: string }) {
  return (
    <div className="page">
      <PageHeader title={title} />
      <section className="card placeholder">
        <Chip tone="blue">{phase}</Chip>
        <h2>Not built yet</h2>
        <p>{blurb}</p>
      </section>
    </div>
  );
}

/** Lead sources is deliberately parked for v2 in the handoff. */
export function LeadSources() {
  return (
    <div className="page">
      <PageHeader title="Lead sources" />
      <section className="card placeholder">
        <Chip tone="amber">Under construction</Chip>
        <h2>Coming in v2</h2>
        <p>We’re reworking how lead sources are measured, using journey milestones instead of bookings. Check back soon.</p>
      </section>
    </div>
  );
}
